import {
  Accordion,
  AccordionSummary,
  Typography,
  AccordionDetails,
  Box,
  Stack,
  Link,
  SvgIcon,
} from '@mui/material';
import { MdExpandMore as ExpandMoreIcon } from 'react-icons/md';
import { ConnectorInstructionsType } from '../connectors-types';
import { FC, useEffect, useState } from 'react';
import { CredentialsType } from '../connector-configure-types';
import { MdOpenInNew as OpenInNewIcon } from 'react-icons/md';

const ConnectorInstructions: FC<
  React.PropsWithChildren<ConnectionInstructionsProps>
> = ({ connectionInstructions, credentialsType }) => {
  const [connectionInstruction, setConnectionInstruction] =
    useState<ConnectorInstructionsType>();

  useEffect(() => {
    setConnectionInstruction(
      connectionInstructions?.find(
        connectionInstruction => connectionInstruction.type === credentialsType,
      ),
    );
  }, [connectionInstructions, credentialsType]);
  const { title, details } = connectionInstruction || {};
  return (
    <Stack spacing={3} sx={{ marginBlockEnd: 3 }}>
      {connectionInstruction && title && details && (
        <Accordion
          disableGutters
          variant='outlined'
          sx={{
            maxHeight: 265,
            overflowY: 'scroll',
          }}>
          <AccordionSummary
            expandIcon={
              <SvgIcon>
                <ExpandMoreIcon />
              </SvgIcon>
            }>
            <Typography color='info.main' variant='overline'>
              {title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ paddingX: 4, paddingTop: 0 }}>
            {details.map((step, index) => (
              <Typography
                py={0.5}
                variant='caption'
                key={step + index}
                color='text.primary'
                component='div'>
                {step}
              </Typography>
            ))}
            {connectionInstruction && connectionInstruction.linksToDocs && (
              <Stack spacing={1} mt={1}>
                {connectionInstruction.linksToDocs.map((linkToDocs, i) => (
                  <Box gap={1} key={linkToDocs.title + i}>
                    <Link target='_blank' href={linkToDocs.href}>
                      {linkToDocs.title} <OpenInNewIcon fontSize='inherit' />
                    </Link>
                  </Box>
                ))}
              </Stack>
            )}
          </AccordionDetails>
        </Accordion>
      )}
    </Stack>
  );
};

interface ConnectionInstructionsProps {
  connectionInstructions: ConnectorInstructionsType[];
  credentialsType: CredentialsType;
}

export default ConnectorInstructions;
